import { INTEGRATION_API } from "../constants";

/**
 * Sends form data to our custom `salesforce/web-to-case` endpoint, where it will
 * then be shipped off to Salesforce. This function replaces the old `hackWebToCase`
 * function.
 *
 * @param {Object} fields an object containing the data from the submitted form
 */

export async function forwardToWebToCaseHandler(fields) {
  const headers = new Headers();
  headers.append("Content-Type", "application/json");

  const response = await fetch(`${INTEGRATION_API.baseUrl}${INTEGRATION_API.endpoints.webToCase}`, {
    method: "POST",
    headers,
    body: JSON.stringify(fields)
  });

  return { status: response.ok ? "success" : "failure" };
}
